import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import Home from "@/pages/Home";
import SampleOneHome from "@/pages/SampleOneHome";
import SampleTwoHome from "@/pages/SampleTwoHome";
import FloorPlanEditor from "@/pages/FloorPlanEditor";
import AIFloorPlanGenerator from "@/pages/AIFloorPlanGenerator";
import Render3D from "@/pages/Render3D";
import Dashboard from "@/pages/Dashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import ProjectView from "@/pages/ProjectView";
import QuestionarioCasas from "@/pages/QuestionarioCasas";
import QuestionarioCarros from "@/pages/QuestionarioCarros";
import VendedorPage from "@/pages/VendedorPage";
import AdminVendedores from "@/pages/AdminVendedores";
import AdminLogin from "@/pages/AdminLogin";
import PainelAdmin from "@/pages/PainelAdmin";
import AdminPanel from "@/pages/AdminPanel";
import QuestionnaireAdmin from "@/pages/QuestionnaireAdmin";
import ProtectedRoute from "@/components/ProtectedRoute";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import './i18n';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Site Principal RH Holdings */}
        <Route path="/" element={<App />} />
        <Route path="/sample-1" element={<SampleOneHome />} />
        <Route path="/sample-2" element={<SampleTwoHome />} />
        
        {/* PropTech Platform Routes */}
        <Route path="/proptech" element={<Home />} />
        <Route path="/desenhar-planta" element={<FloorPlanEditor />} />
        <Route path="/gerar-planta" element={<AIFloorPlanGenerator />} />
        <Route path="/render-3d/:projectId" element={<Render3D />} />
        <Route path="/projeto/:projectId" element={<ProjectView />} />
        <Route path="/dashboard" element={<Dashboard />} />
        
        {/* Admin Panel - New Style (like questionnaire-system) */}
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/admin/questionario" element={<QuestionnaireAdmin />} />
        
        {/* Legacy Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/projetos" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin/vendedores" element={
          <ProtectedRoute>
            <AdminVendedores />
          </ProtectedRoute>
        } />
        
        {/* Painel Admin (old style) */}
        <Route path="/painel" element={<PainelAdmin />} />
        
        {/* Questionário Routes */}
        <Route path="/questionario-casas" element={<QuestionarioCasas />} />
        <Route path="/questionario-carros" element={<QuestionarioCarros />} />
        
        {/* Vendedores Routes */}
        <Route path="/v/:codigo" element={<VendedorPage />} />
        
        {/* Short Links - RH Holdings Format */}
        <Route path="/rh/:codigo" element={<VendedorPage />} />
        <Route path="/rh/:codigo/carros" element={<QuestionarioCarros />} />
        <Route path="/rh/:codigo/casas" element={<QuestionarioCasas />} />
        
        {/* Legacy short links */}
        <Route path="/c/:codigo" element={<QuestionarioCarros />} />
        <Route path="/h/:codigo" element={<QuestionarioCasas />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);

serviceWorkerRegistration.register();
